module.exports = __webpack_public_path__ + "img/2006_S.b0f051bd.png";